"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MstrCoverTemplate = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const organisation_entity_1 = require("./organisation.entity");
const look_up_entity_1 = require("./look-up.entity");
let MstrCoverTemplate = class MstrCoverTemplate {
    constructor(refCoverId, coverName, coverDescription, mandatory, organizationId, policyTypeId, displaySequence, displayCategory, coverTypeLid, inputType, inputLov, coversMeta) {
        this.refCoverId = refCoverId;
        this.coverName = coverName;
        this.coverDescription = coverDescription;
        this.mandatory = mandatory;
        this.organizationId = organizationId;
        this.policyTypeId = policyTypeId;
        this.displaySequence = displaySequence;
        this.displayCategory = displayCategory;
        this.coverTypeLid = coverTypeLid;
        this.inputType = inputType;
        this.inputLov = inputLov;
        this.coversMeta = coversMeta;
    }
};
exports.MstrCoverTemplate = MstrCoverTemplate;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "ref_cover_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "refCoverId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "varchar", length: 200, nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrCoverTemplate.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrCoverTemplate.prototype, "coverDescription", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mandatory", type: "varchar", length: 10, default: "Yes" }),
    tslib_1.__metadata("design:type", String)
], MstrCoverTemplate.prototype, "mandatory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "organization_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "organizationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "policyTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "display_sequence", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "displaySequence", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "display_category",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], MstrCoverTemplate.prototype, "displayCategory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_type", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "coverTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "input_type", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrCoverTemplate.prototype, "inputType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "input_lov", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], MstrCoverTemplate.prototype, "inputLov", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "covers_meta", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Record !== "undefined" && Record) === "function" ? _d : Object)
], MstrCoverTemplate.prototype, "coversMeta", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], MstrCoverTemplate.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], MstrCoverTemplate.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrCoverTemplate.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => organisation_entity_1.Organisation, (org) => org.id, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "organization_id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], MstrCoverTemplate.prototype, "organisation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "cover_type", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _h : Object)
], MstrCoverTemplate.prototype, "coverType", void 0);
exports.MstrCoverTemplate = MstrCoverTemplate = tslib_1.__decorate([
    (0, typeorm_1.Entity)("mstr_cover_template"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, Number, Number, Number, String, Number, String, typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object, typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object])
], MstrCoverTemplate);
